import { Form, Formik } from 'formik';
import { Props, Values } from './TeamMemberForm.types';
import FormField from '../../components/field/FormField';
import { TeamMemberPermissionForm } from './TeamMemberPermissionForm';
import { useParams } from 'react-router-dom';
import { useTranslation } from '../../context/translationContext';
import Button from '../../components/button/Button';

/**
 * Form to edit team member
 * only permissions now, more in future
 */
export const TeamMemberForm = ({ initialValues, onBack }: Props) => {
  const { t } = useTranslation();
  const { membershipId } = useParams();
  const _initialValues: Values = {
    userName: '',
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues || _initialValues}
      onSubmit={() => {
        null;
      }}
    >
      {({ errors, touched }) => (
        <Form>
          <div className="my-4">
            <FormField
              id="userName"
              name="userName"
              label={t('page.team-member.input-username')}
              errors={errors}
              touched={touched}
              readOnly
              disabled
            />
          </div>

          {membershipId && (
            <div className="my-4">
              <TeamMemberPermissionForm teamMemberId={Number(membershipId)} />
            </div>
          )}
          <div className="float-left">
            <Button title={t('general.back')} color="gray" className="mr-3" onClick={onBack} />
          </div>
        </Form>
      )}
    </Formik>
  );
};
